import { OidcConfiguration, TokenRenewMode } from '@axa-fr/react-oidc';

import env from '~/env';

export const config: OidcConfiguration = {
	client_id: env.VITE_IDP_CLIENT_ID,
	redirect_uri: `${window.location.origin}/callback`,
	scope: 'openid profile roles offline_access MDD.External',
	authority: env.VITE_IDP_URL,
	token_renew_mode: TokenRenewMode.access_token_invalid,
	// If mocks are enabled, the msw service worker will register the oidc one too
	service_worker_relative_url:
		env.VITE_USE_MOCKS ? undefined : '/OidcServiceWorker.js',
	service_worker_only: true,
};
